module.exports = __webpack_public_path__ + "assets/img/home2-box2-4.99aa4c00.png";